<template>
  <modal class="q-modal acl-item" name="acl-config-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="800"
       :minWidth="800"
       :height="'auto'"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">
        {{modalTitle}}
      </div>
      <div class="icon-btn_close modal-close" @click="onClose()">
      </div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="form">
              <div class="formRow dt">
                <div class="dt-r">
                  <div class="title dt-c">{{$t('acl.popupNo')}}</div>
                  <div class="forminput dt-c">
                    <input v-if="isAdd" name="ID" class="form-control number-input" type="text" :class="{'error': errors.has('ID') || alreadyExist }" v-model="aclId" v-validate="'required|numeric|max_value:255|min_value:1'" @keyup="onBlur" @change="onBlur" @keypress="onlyNumber" min="1">
                    <div v-else>{{aclId}}</div>
                  </div>
                </div>
                <div class="dt-r">
                  <div class="dt-c"></div>
                  <div v-if="errors.has('ID') || alreadyExist" class="errorMessage dt-c">{{(alreadyExist) ? $t('errorMessage.aclIDused') : setErrorMessage(errors.first('ID')) }}</div>
                </div>
              </div>
              <!-- <div class="formRow" v-if="type === 'ip'">
                <div class="title">{{$t('acl.popupDirection')}}</div>
                <div class="radio">
                  <radio class="permit" :label="$t('acl.ingress')" :checked="isItemChecked(radioItems[2])" @click.native="onSelection(radioItems[2])"></radio>
                  <radio :label="$t('acl.egress')" :checked="isItemChecked(radioItems[3])" @click.native="onSelection(radioItems[3])"></radio>
                </div>
              </div> -->
              <div class="formRow">
                <div class="title">{{$t('acl.source')}}</div>
                <div class="formRow-content">
                  <div class="formRow dt" v-if="type === 'ip'">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('acl.popupIP')}}</div>
                      <div class="forminput dt-c">
                        <input name="sourceIP" class="form-control addressInput" type="text" :placeholder="$t('acl.any')" v-model="sourceIP" @keyup="onBlur" v-validate="'ip'" :class="{'error': errors.has('sourceIP') }">
                      </div>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="errors.has('sourceIP')" class="errorMessage dt-c">{{ setErrorMessage(errors.first('sourceIP')) }}</div>
                    </div>
                  </div>
                  <div class="formRow dt" v-if="type === 'ip'">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('acl.popupMask')}}</div>
                      <div class="forminput dt-c">
                        <input name="sourceMask" class="form-control addressInput" type="text" :placeholder="$t('acl.any')" v-model="sourceMask" @keyup="onBlur" v-validate="'ip'" :class="{'error': errors.has('sourceMask') }">
                      </div>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="errors.has('sourceMask')" class="errorMessage dt-c">{{ setErrorMessage(errors.first('sourceMask')) }}</div>
                    </div>
                  </div>
                  <div class="formRow dt" v-if="type === 'mac'">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('overview.macaddress')}}</div>
                      <div class="forminput dt-c">
                        <input name="sourceMAC" class="form-control addressInput" type="text" :placeholder="$t('acl.any')" v-model="sourceAddress" @keyup="onBlur" v-validate="'macaddress'" :class="{'error': errors.has('sourceMAC') }">
                      </div>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="errors.has('sourceMAC')" class="errorMessage dt-c">{{ setErrorMessage(errors.first('sourceMAC')) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="formRow">
                <div class="title">{{$t('acl.destination')}}</div>
                <div class="formRow-content">
                  <div class="formRow dt" v-if="type === 'ip'">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('acl.popupIP')}}</div>
                      <div class="forminput dt-c">
                        <input name="destinationIP" class="form-control addressInput" type="text" :placeholder="$t('acl.any')" v-model="destinationIP" @keyup="onBlur" v-validate="'ip'" :class="{'error': errors.has('destinationIP') }">
                      </div>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="errors.has('destinationIP')" class="errorMessage dt-c">{{ setErrorMessage(errors.first('destinationIP')) }}</div>
                    </div>
                  </div>
                  <div class="formRow dt" v-if="type === 'ip'">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('acl.popupMask')}}</div>
                      <div class="forminput dt-c">
                        <input name="destinationMask" class="form-control addressInput" type="text" :placeholder="$t('acl.any')" v-model="destinationMask" @keyup="onBlur" v-validate="'ip'" :class="{'error': errors.has('destinationMask') }">
                      </div>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="errors.has('destinationMask')" class="errorMessage dt-c">{{ setErrorMessage(errors.first('destinationMask')) }}</div>
                    </div>
                  </div>
                  <div class="formRow dt" v-if="type === 'mac'">
                    <div class="dt-r">
                      <div class="title dt-c">{{$t('overview.macaddress')}}</div>
                      <div class="forminput dt-c">
                        <input name="desMAC" class="form-control addressInput" type="text" :placeholder="$t('acl.any')" v-model="desAddress" @keyup="onBlur" v-validate="'macaddress'" :class="{'error': errors.has('desMAC') }">
                      </div>
                    </div>
                    <div class="dt-r">
                      <div class="dt-c"></div>
                      <div v-show="errors.has('desMAC')" class="errorMessage dt-c">{{ setErrorMessage(errors.first('desMAC')) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="formRow note">
                <icon-remind class="remind"></icon-remind>
                <span class="note-title">{{$t('acl.defaultTip')}}</span>
              </div>
              <div class="formRow">
                <div class="title">{{$t('acl.port')}}</div>
                <div class="all-port" @click="onSelection('all')">
                  <checkbox class="q-checkbox-label" :checked="selectAll" :id="'checkbox-all'"></checkbox>
                  <span>{{$t('all')}}</span>
                </div>
              </div>
              <div class="formRow">
                <div class="forminput port">
                  <div class="port-select">
                    <table>
                      <tr class="table-header">
                        <td style="width:20%;">{{$t('overview.portNo')}}</td>
                        <td :style="{ width: (80/ portNumber)+'%' }" v-for="num in portNumber" :key="num">{{num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:20%;">{{$t('selected')}}</td>
                        <td class="table-body-content" :style="{ width: (80/ portNumber)+'%' }" v-for="num in portNumber" :key="num">
                          <div class="formlabel fontB subitem" @click="onSelection(num)" :title="getTips(num)">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked(num)" :disabled="getDisabled(num)" :id="'checkbox-' + (num)"></checkbox>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="formRow">
                <div class="title">{{$t('rule')}}</div>
                <div class="radio">
                  <radio class="permit" :label="$t('acl.allow')" :checked="isItemChecked(radioItems[0])" @click.native="onSelection(radioItems[0])" :id="'radio-allow'"></radio>
                  <radio :label="$t('acl.deny')" :checked="isItemChecked(radioItems[1])" @click.native="onSelection(radioItems[1])" :id="'radoi-deny'"></radio>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button blue-btn-full" @click="onSaveClick()" :disabled="!saveBtn" :title="$t('save')">{{$t('save')}}</button>
          <button class="q-button" @click="onClose()" :title="$t('cancel')">{{$t('cancel')}}</button>
        </div>
      </div>
      <popup-confirm name="acl-iptable-confirm" :dialog-header="$t('warning')" :dialog-message="confirmMsg[0]" :dialog-message2="confirmMsg[1]" icon="w" :onlyOk="true" />
      <popup-confirm name="mask-warning-modal" :dialog-header="$t('warning')" :dialog-message="$t('acl.confirmContent3')" :selHeight="220" icon="w" :callback="goIPsave" />
      <popup-confirm name="acl-rule-warning" :dialog-header="$t('warning')" :dialog-message="$t('acl.rulesLimit')" icon="w" :onlyOk="true"></popup-confirm>
    </div>
  </modal>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import checkbox from './module/Checkbox'
import Radio from './module/Radio'
import qSelect from './module/Select.vue'
import iconRemind from '../assets/svg/ic_system_remind.svg'
export default {
  name: 'acl-item',
  props: {
    selectObj: Object,
    onChange: Function,
    isAdd: Boolean,
    type: String,
    existNumber: Array,
    aclCount: Number
  },
  components: {
    Radio,
    qSelect,
    checkbox,
    iconRemind
  },
  data () {
    return {
      modalname: 'acl-config-modal',
      showModal: true,
      aclId: null,
      sourceAddress: null,
      desAddress: null,
      selDirection: 'in',
      protocol: 'tcp',
      sourceIP: null,
      sourceMask: null,
      destinationIP: null,
      destinationMask: null,
      permission: null,
      saveBtn: false,
      errorMessage: '',
      isIDValidation: true,
      isAddressValidation: true,
      selectedList: [],
      radioItems: ['permit', 'deny', 'in', 'out'],
      selectData: null,
      isShowMaskWarning: false,
      selectPort: [],
      alreadyExist: false,
      confirmMsg: [],
      selectAll: false
    }
  },
  watch: {
    selectObj: function (value) {
      this.$log.debug(value)
      if (value.data) {
        this.setData()
      } else {
        this.aclId = value.number
        this.permission = 'permit'
        this.selDirection = 'in'
        this.selectAll = false
      }
    }
  },
  created: async function () {
    let me = this
    this.$validator.extend('macaddress', {
      getMessage (field, val) {
        return me.$t('errorMessage.macFormat')
      },
      validate (value, field) {
        var temp = /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/
        if (value.toLowerCase() === 'any') {
          return true
        } else {
          if (temp.test(value)) {
            return true
          }
          return false
        }
      }
    })
    this.$validator.extend('ip', {
      getMessage (field, val) {
        return me.$t('errorMessage.ipFormat')
      },
      validate (value, field) {
        var temp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
        if (value.toLowerCase() === 'any') {
          return true
        } else {
          if (temp.test(value)) {
            return true
          }
          return false
        }
      }
    })
  },
  methods: {
    ...mapActions(['setIPacl', 'setMACacl', 'addIPacl', 'addMACacl']),
    ...mapMutations(['openModal', 'closeModal']),
    Opened (event) {
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let height = document.body.clientHeight
      let modalH = this.$el.getElementsByClassName('q-v--modal')[0].offsetHeight
      let winWidth = document.body.clientWidth
      let tempW = (winWidth > 800) ? 800 : winWidth - 90
      if (modalH > height && modal) {
        modal.style.height = (height - 90) + 'px'
        modal.style.top = 'calc(50% - ' + ((height - 90) / 2) + 'px'
      }
      if (modal) {
        modal.style.width = tempW + 'px'
        modal.style.left = 'calc(50% - ' + (tempW / 2) + 'px'
      }
      this.$refs.scrollbar.onResize()
    },
    setInitial: function () {
      this.sourceAddress = null
      this.desAddress = null
      this.aclId = null
      this.sourceIP = null
      this.sourceMask = null
      this.destinationIP = null
      this.destinationMask = null
      this.permission = 'permit'
      this.selDirection = 'in'
      this.selectPort = []
      this.saveBtn = false
      this.isShowMaskWarning = false
      this.alreadyExist = false
    },
    setData: function () {
      this.aclId = (this.type === 'ip') ? this.selectObj.data.key - 1000 : this.selectObj.data.key
      this.selDirection = (this.selectObj.data.val.direction === 1) ? 'in' : 'out'
      this.permission = (this.selectObj.data.val.action === 1) ? 'permit' : 'deny'
      this.selectPort = JSON.parse(JSON.stringify(this.selectObj.data.val.portList))
      this.selectPort.length === this.portNumber ? this.selectAll = true : this.selectAll = false
      if (this.type === 'mac') {
        if (this.selectObj.data.val.sourceMAC !== '00:00:00:00:00:00') {
          this.sourceAddress = this.selectObj.data.val.sourceMAC
        }
        if (this.selectObj.data.val.destinationMAC !== '00:00:00:00:00:00') {
          this.desAddress = this.selectObj.data.val.destinationMAC
        }
      } else {
        if (this.selectObj.data.val.sourceIP !== '0.0.0.0') {
          this.sourceIP = this.selectObj.data.val.sourceIP
        }
        if (this.selectObj.data.val.sourceMask !== '0.0.0.0') {
          this.sourceMask = this.selectObj.data.val.sourceMask
        }
        if (this.selectObj.data.val.destinationIP !== '0.0.0.0') {
          this.destinationIP = this.selectObj.data.val.destinationIP
        }
        if (this.selectObj.data.val.destinationMask !== '0.0.0.0') {
          this.destinationMask = this.selectObj.data.val.destinationMask
        }
      }
    },
    isItemChecked: function (item) {
      if (item === 'in' || item === 'out') {
        return (item === this.selDirection)
      } else if (item === 'permit' || item === 'deny') {
        return (item === this.permission)
      } else {
        let index = this.selectPort.indexOf(item + '')
        return (index > -1)
      }
    },
    onSelection: function (item) {
      if (item === 'all') {
        this.selectAll = !this.selectAll
        let temp = []
        if (this.selectAll) {
          for (let idx = 0; idx < this.portNumber; idx++) {
            if (!this.portMap.get(idx + 1)) {
              temp.push('' + (idx + 1))
            }
          }
          this.selectPort = temp
        } else {
          this.selectPort = []
        }
      } else {
        if (item === 'in' || item === 'out') {
          this.selDirection = item
        } else if (item === 'permit' || item === 'deny') {
          this.permission = item
        } else {
          if (!this.portMap.get(item)) {
            let index = this.selectPort.indexOf(item + '')
            if (index > -1) {
              this.selectPort.splice(index + '', 1)
            } else {
              this.selectPort.push(item + '')
            }
            this.selectPort.length === this.portNumber ? this.selectAll = true : this.selectAll = false
          }
        }
      }
      this.checkValidation()
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
      this.setInitial()
    },
    onBlur: function (event) {
      this.checkValidation(event.target.name)
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      let isFunctionKey = false
      switch (keyCode) {
        case 8:
          isFunctionKey = true
          break
      }
      if ((keyCode < 48 || keyCode > 57) && !isFunctionKey) { // 46 is dot
        $event.preventDefault()
      }
    },
    setErrorMessage: function (data) {
      let message = null
      if (data) {
        if (data.indexOf('ID') > -1) {
          message = this.$t('errorMessage.aclRange')
        } else {
          message = data
        }
      }
      return message
    },
    onCheckInput: function () {
      let value = true
      var sIp = (!this.sourceIP || this.sourceIP.toLowerCase() === 'any') ? 1 : 0
      var sMask = (!this.sourceMask || this.sourceMask.toLowerCase() === 'any') ? 1 : 0
      var dIp = (!this.destinationIP || this.destinationIP.toLowerCase() === 'any') ? 1 : 0
      var dMask = (!this.destinationMask || this.destinationMask.toLowerCase() === 'any') ? 1 : 0
      this.confirmMsg = []
      if ((!sIp && !sMask) || (sIp && sMask)) {
        if (!sMask && this.sourceMask !== '255.255.255.255') {
          this.isShowMaskWarning = true
        }
      } else {
        this.confirmMsg.push(this.$t('acl.confirmContent1'))
        value = false
      }
      if ((!dIp && !dMask) || (dIp && dMask)) {
        if (!dMask && this.destinationMask !== '255.255.255.255') {
          this.isShowMaskWarning = true
        }
      } else {
        this.confirmMsg.push(this.$t('acl.confirmContent2'))
        value = false
      }
      return value
    },
    goIPsave: function () {
      let data = this.selectData
      if (this.isAdd) {
        data['idx'] = parseInt(this.aclId) + 1000 + ''
        this.addIPacl(data)
          .then((result) => {
            if (result.data.error_code === 200) {
              this.onChange()
              this.onClose()
            } else {
              this.$log.debug(result.data)
            }
          }).catch((err) => {
            this.openModal('acl-rule-warning')
            this.$modal.show('acl-rule-warning')
            this.$log.error(err)
          })
      } else {
        data['idx'] = this.selectObj.data.key
        if (!this.checkEditCountValidation()) return false
        this.setIPacl(data)
          .then((result) => {
            if (result.data.error_code === 200) {
              this.onChange()
              this.onClose()
            } else {
              this.$log.debug(result.data)
            }
          }).catch((err) => {
            this.$log.error(err)
          })
      }
    },
    goMACsave: function () {
      let data = this.selectData
      if (this.isAdd) {
        data['idx'] = this.aclId + ''
        this.addMACacl(data)
          .then((result) => {
            if (result.data.error_code === 200) {
              this.onChange()
              this.onClose()
            } else {
              this.$log.debug(result.data)
            }
          }).catch((err) => {
            this.openModal('acl-rule-warning')
            this.$modal.show('acl-rule-warning')
            this.$log.error(err)
          })
      } else {
        data['idx'] = this.selectObj.data.key
        if (!this.checkEditCountValidation()) return false
        this.setMACacl(data)
          .then((result) => {
            if (result.data.error_code === 200) {
              this.onChange()
              this.onClose()
            } else {
              this.$log.debug(result.data)
            }
          }).catch((err) => {
            this.$log.error(err)
          })
      }
    },
    onSaveClick: function () {
      let direction = 1
      let permit = (this.permission === 'permit') ? 1 : 2
      let checkValid = true
      if (this.type === 'mac') {
        this.selectData = {
          val: {
            action: permit,
            direction: direction,
            sourceMAC: (!this.sourceAddress || this.sourceAddress.toLowerCase() === 'any') ? '0:0:0:0:0:0' : this.sourceAddress,
            destinationMAC: (!this.desAddress || this.desAddress.toLowerCase() === 'any') ? '0:0:0:0:0:0' : this.desAddress,
            portList: this.selectPort,
            priority: parseInt(this.aclId)
          }
        }
        this.goMACsave()
      } else {
        checkValid = this.onCheckInput()
        this.selectData = {
          val: {
            action: permit,
            direction: direction,
            destinationIP: (!this.destinationIP || this.destinationIP.toLowerCase() === 'any') ? '0.0.0.0' : this.destinationIP,
            destinationMask: (!this.destinationMask || this.destinationMask.toLowerCase() === 'any') ? '0.0.0.0' : this.destinationMask,
            sourceIP: (!this.sourceIP || this.sourceIP.toLowerCase() === 'any') ? '0.0.0.0' : this.sourceIP,
            sourceMask: (!this.sourceMask || this.sourceMask.toLowerCase() === 'any') ? '0.0.0.0' : this.sourceMask,
            portList: this.selectPort,
            priority: parseInt(this.aclId)
          }
        }
        if (checkValid) {
          if (this.isShowMaskWarning) {
            this.openModal('mask-warning-modal')
            this.$modal.show('mask-warning-modal')
          } else {
            this.goIPsave()
          }
        } else {
          this.openModal('acl-iptable-confirm')
          this.$modal.show('acl-iptable-confirm')
        }
      }
    },
    checkCellValidation: function () {
      this.selectPort.length > 0 ? this.saveBtn = true : this.saveBtn = false
    },
    checkValidation: function () {
      if (this.isAdd && this.existNumber.indexOf(parseInt(this.aclId)) > -1) {
        this.alreadyExist = true
        this.saveBtn = false
      } else {
        this.alreadyExist = false
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.checkCellValidation()
          } else {
            this.saveBtn = result
          }
        })
      }
    },
    checkEditCountValidation () {
      let count = (this.selectAll) ? 1 : this.selectPort.length
      let preCount = (this.selectObj.data.val.portList.length === this.portNumber) ? 1 : this.selectObj.data.val.portList.length
      if ((this.aclCount - preCount + count) > 255) {
        this.openModal('acl-rule-warning')
        this.$modal.show('acl-rule-warning')
        return false
      }
      return true
    },
    onMenuChange (value) {
      this.selectPort = value
    },
    getDisabled (port) {
      if (this.portMap.get(port)) {
        return true
      }
      return false
    },
    getTips (port) {
      let title = ''
      if (this.portMap.get(port)) {
        title = this.$t('errorMessage.existInLag')
      }
      return title
    }
  },
  computed: {
    ...mapState({
      portMap: state => state.module.portMap,
      portNumber: state => state.module.portNum
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    modalTitle () {
      if (this.type === 'ip') {
        return (this.isAdd) ? this.$t('acl.addIPTitle') : this.$t('acl.editIPTitle')
      } else {
        return (this.isAdd) ? this.$t('acl.addMacTitle') : this.$t('acl.editMacTitle')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/modal.scss';

.acl-item {
  .modal-container {
    .formRow {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0px;
      }
      .title, .forminput {
        display: inline-block;
      }
      .title {
        width: 110px;
        padding-right: 10px;
      }
      .forminput.port-table {
        width: 100%;
        display: block;
      }
      .forminput {
        &.port {
          width: 100%;
        }
        .port-select {
          // margin-top: 10px;
          >table {
            margin-top: 8px;
            width: 100%;
            text-align: center;
            td {
              border: 1px solid #F1F1F1;
            }
            .table-header {
              background: #F2F3F8;
              height: 28px;
              text-align: center;
            }
            .table-body {
              height: 38px;
            }
          }
        }
      }
      .radio {
        display: inline-block;
        vertical-align: text-top;
        margin: 0px 10px;
        >.q-radio {
          display: block;
        }
      }
      .formRow-content {
        margin-left: 20px;
        margin-top: 15px;
      }
      .number-input {
        width: 70px;
      }
      .all-port {
        display: inline-block;
        line-height: 28px;
        .q-checkbox-label {
          vertical-align: sub;
        }
      }
      &.note {
        font-family: 'Roboto-R';
        font-size: 14px;
        color: #195A87;
        text-align: left;
        line-height: 18px;
        .remind {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        .note-title {
          line-height: 18px;
          vertical-align: text-bottom;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AclItem.vue